"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _FullBar = _interopRequireDefault(require("../baseComponents/FullBar"));
var _OverlayHandler = _interopRequireDefault(require("../../handlers/OverlayHandler"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var TaskBar = /*#__PURE__*/function (_Component) {
  function TaskBar(props) {
    var _this;
    _classCallCheck(this, TaskBar);
    _this = _callSuper(this, TaskBar, [props]);
    _defineProperty(_this, "taskBarDefinition", null);
    _this.show = _this.show.bind(_this);
    _this.hide = _this.hide.bind(_this);
    _this.setNewState = _this.setNewState.bind(_this);
    _this.setStateFromProps = _this.setStateFromProps.bind(_this);
    _this.isShowing = _this.isShowing.bind(_this);
    _this.getUpdatedPosition = _this.getUpdatedPosition.bind(_this);
    _this.taskBarDefinition = _this.setStateFromProps(props);
    _this.state = _this.setStateFromProps(props);
    return _this;
  }
  _inherits(TaskBar, _Component);
  return _createClass(TaskBar, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      if (!prevState.display && this.state.display) {
        this.getUpdatedPosition();
      }
    }
  }, {
    key: "show",
    value: function show() {
      var _this2 = this;
      setTimeout(function () {
        _this2.setState({
          display: true
        });
      }, this.state.showAfter);
    }
  }, {
    key: "hide",
    value: function hide() {
      var _this3 = this;
      var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
      setTimeout(function () {
        _this3.setState({
          display: false
        });
        callback();
      }, this.state.hideAfter);
    }
  }, {
    key: "getUpdatedPosition",
    value: function getUpdatedPosition() {
      var position = {};
      var overlayRect = document.querySelector(".overlay-component.show .overlayContentContainer");
      var taskbarRect = document.querySelector(".taskBar-component .taskBarContentContainer");
      if (!overlayRect || !taskbarRect || !_OverlayHandler["default"].isShowing()) {
        position = {};
      } else {
        overlayRect = overlayRect.getBoundingClientRect();
        taskbarRect = taskbarRect.getBoundingClientRect();
        position = {
          position: "fixed",
          top: overlayRect.y + overlayRect.height - taskbarRect.height - 24 + "px",
          left: overlayRect.x + overlayRect.width - taskbarRect.width - 24 + "px"
        };
      }
      this.setState({
        adjustedPosition: position
      });
    }
  }, {
    key: "setNewState",
    value: function setNewState(state) {
      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
      this.setState(this.setStateFromProps(state), function () {
        callback();
      });
    }
  }, {
    key: "isShowing",
    value: function isShowing() {
      return this.state.display;
    }
  }, {
    key: "setStateFromProps",
    value: function setStateFromProps(props) {
      var nextProps = props || {};
      var definition = this.taskBarDefinition || {};
      return {
        display: this.state ? this.state.display : false,
        type: nextProps.type || definition.type || "default",
        position: nextProps.position || definition.position || "bottom",
        className: nextProps.className || definition.className || "",
        style: nextProps.style || definition.style || null,
        tasks: nextProps.tasks || definition.tasks || null,
        hideAfter: nextProps.hideAfter || definition.hideAfter || 0,
        showAfter: nextProps.showAfter || definition.showAfter || 0
      };
    }
  }, {
    key: "render",
    value: function render() {
      var classes = (0, _classnames["default"])("taskBar-component", this.state.className, this.state.type, this.state.position, {
        "show": this.state.display,
        "overlayOpened": _OverlayHandler["default"].isShowing()
      });
      var tasks = this.state.tasks;
      return /*#__PURE__*/_react["default"].createElement("div", {
        id: "taskBar-component",
        className: classes,
        style: _objectSpread({}, this.state.style)
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "taskBarContentContainer",
        style: this.state.adjustedPosition
      }, Array.isArray(tasks) ? tasks.map(function (task, index) {
        var classes = (0, _classnames["default"])("task", task.className, {
          "manualContent": task.manualContent
        });
        return /*#__PURE__*/_react["default"].createElement("div", {
          key: index,
          className: classes
        }, task.content);
      }) : tasks));
    }
  }]);
}(_react.Component);
;
TaskBar.propTypes = {
  type: _propTypes["default"].oneOf(["default"]),
  position: _propTypes["default"].oneOf(["bottom", "top"]),
  tasks: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].shape({
    manualContent: _propTypes["default"].bool,
    content: _propTypes["default"].any,
    className: _propTypes["default"].string
  })), _propTypes["default"].object]),
  className: _propTypes["default"].string,
  style: _propTypes["default"].object
};
TaskBar.defaultProps = {
  type: "default",
  position: "bottom",
  task: []
};
var _default = exports["default"] = TaskBar;